import { updateUser as updateUserAPI } from "../api";

export const updateUserAction = async (userEmail, userName, isTeacher, setUser) => {
  const user = await updateUserAPI(userEmail, userName, isTeacher);
  setUser(user.data);
};
